import React, {useState} from "react";

const normalizeImageUrl = (url) => {
    if (!url) return url;
    return url.replace("/api/media/api/media/", "/api/media/");
};

const Team = ({data}) => {
    const [openId, setOpenId] = useState(null);

    const toggleBio = (id) => {
        setOpenId(prev => (prev === id ? null : id));
    };
    return (
        <section className="team-one">
            <div className="container">
                <div className="section-title tg-heading-subheading animation-style2">
                    <h5 className="tg-element-title" style={{perspective: 400}}>
                        <div
                            className="split-line"
                            style={{display: "block", textAlign: "start", position: "relative"}}
                        >
                            <div style={{position: "relative", display: "inline-block"}}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    O
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    u
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    r
                                </div>
                            </div>
                            {" "}
                            <div style={{position: "relative", display: "inline-block"}}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    a
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    c
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    t
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    i
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    v
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    e
                                </div>
                            </div>
                            {" "}
                            <div style={{position: "relative", display: "inline-block"}}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    m
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    e
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    m
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    b
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    e
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    r
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    s
                                </div>
                            </div>
                        </div>
                    </h5>
                    <h2 className="tg-element-title" style={{perspective: 400}}>
                        <div
                            className="split-line"
                            style={{display: "block", textAlign: "start", position: "relative"}}
                        >
                            <div style={{position: "relative", display: "inline-block"}}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    T
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    r
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    a
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    n
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    s
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    f
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    o
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    r
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    m
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    i
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    n
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    g
                                </div>
                            </div>
                            {" "}
                            <div style={{position: "relative", display: "inline-block"}}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    C
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    h
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    a
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    l
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    l
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    e
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    n
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    g
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    e
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    s
                                </div>
                            </div>
                            {" "}
                            <div style={{position: "relative", display: "inline-block"}}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    i
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    n
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    t
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    o
                                </div>
                            </div>
                            {" "}
                        </div>
                        <div
                            className="split-line"
                            style={{display: "block", textAlign: "start", position: "relative"}}
                        >
                            <div style={{position: "relative", display: "inline-block"}}>
                                {" "}
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    S
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    e
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    a
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    m
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    l
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    e
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    s
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    s
                                </div>
                            </div>
                            {" "}
                            <div style={{position: "relative", display: "inline-block"}}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    S
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    o
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    l
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    u
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    t
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    i
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    o
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    n
                                </div>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        transform: "translate(0px, 0px)",
                                        opacity: 1
                                    }}
                                >
                                    s
                                </div>
                            </div>
                        </div>
                    </h2>
                </div>
                <div className="row">
                    {/* Start Team-One Single*/}
                    {data.length > 0 ?
                        data.map(member => (
                            <div
                                key={member.id}
                                className="col-xl-3 col-lg-4 col-md-6 mt-4 mx-auto wow fadeInLeft"
                                data-wow-delay="200ms"
                                style={{
                                    visibility: "visible",
                                    animationDelay: "200ms",
                                    animationName: "fadeInLeft"
                                }}
                            >
                                <div className="team-one__single" onClick={() => toggleBio(member.id)} style={{cursor: "pointer"}}>
                                    <div className="team-one__single-img">
                                        <img src={normalizeImageUrl(member.image)} alt={member.name} height="340px"/>
                                    </div>
                                    <div className="team-one__single-content text-center">
                                        <h2>
                                            <a href="#">{member.name}</a>
                                        </h2>
                                        <p>{member.role}</p>
                                        {member.bio ? (
                                            <p style={{
                                                marginTop: "10px",
                                                display: openId === member.id ? "block" : "none"
                                            }}>
                                                {member.bio}
                                            </p>
                                        ) : null}
                                    </div>
                                </div>
                            </div>))
                        : <div className="text-danger mx-auto text-center">
                            <span className="fw-bolder">NO TEAM AVAILABLE</span>
                        </div>}
                    {/* End Team-One Single*/}
                </div>
            </div>
        </section>
    );
}

export default Team
